export default __webpack_public_path__ + "static/media/feature-box-collection-wwII-550x310.8777dc98.jpg";